import React from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import api from "../../lib/api";
import Grain from "../../components/Grain";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const expired = new URLSearchParams(location.search).get("expired") === "1";
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [err, setErr] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("se_admin_token", r.data.token);
      localStorage.setItem("se_admin_email", r.data.email);
      navigate("/admin/dashboard");
    } catch (e) {
      setErr("Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen section-dark flex items-center justify-center px-6 relative overflow-hidden">
      <Grain/>
      <div className="absolute inset-0 glow-amber-soft pointer-events-none"/>
      <form onSubmit={submit} data-testid="admin-login-form" className="relative z-10 w-full max-w-md border border-white/10 p-10 bg-dark/80 backdrop-blur">
        <Link to="/" className="block text-center font-serif text-2xl">
          Studio <span className="italic-accent">Euclides</span>
        </Link>
        <div className="eyebrow text-center mt-2 mb-10 text-text-cream/50">Espace administration</div>
        {expired && (
          <div
            className="mb-6 p-3 border border-accent-deep/40 bg-accent-deep/10 text-accent-light text-xs rounded"
            data-testid="session-expired-notice"
          >
            Ta session a expiré. Reconnecte-toi pour continuer.
          </div>
        )}
        <div className="space-y-6">
          <div>
            <label className="eyebrow mb-2 block">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="input-editorial"/>
          </div>
          <div>
            <label className="eyebrow mb-2 block">Mot de passe</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="input-editorial"/>
          </div>
          {err && <div className="text-red-400 text-sm" data-testid="admin-error">{err}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="admin-submit">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </div>
      </form>
    </div>
  );
}
